import { useState, useEffect } from 'react';
import Navbar from '../../Navbar';
import Sidebar from '../../Sidebar';
import $ from 'jquery';
import Modal from 'react-bootstrap/Modal';
import 'datatables.net-bs5';
import { useNavigate } from 'react-router-dom';
import { BASE_URL, USER_ID, TOKEN } from '../../commonConstants';
import axios from 'axios';


const Leads = ({ userName, role, onLogout }) => {

	// const [email, setEmail] = useState('');

	const [success, setSuccess] = useState(false);
	const [error, setError] = useState(null);
	const [firstNameError, setFirstNameError] = useState('');
	const [lastNameError, setLastNameError] = useState('');

	const [emailError, setEmailError] = useState('');
	const [companyNameError, setCompanyNameError] = useState('');
	const [websiteError, setWebsiteError] = useState('');
	const [phoneError, setPhoneError] = useState('');
	const [regionError, setRegionError] = useState('');
	const [countryError, setCountryError] = useState('');
	const [leadTypeError, setLeadTypeError] = useState('');
	const [leadStatusError, setLeadStatusError] = useState('');

	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]); // Define state variable to hold data
	const [show, setShow] = useState(false);
	const [fadeOut, setFadeOut] = useState(false);

	const navigate = useNavigate();

	// Define editPartner and viewPartnerLeads functions within useEffect
	const editLead = (pid) => {
		navigate(`/edit-lead/${pid}`);
	};

	const [leadData, setLeadData] = useState({
		fname: '',
		lname: '',
		email: '',
		company_name: '',
		phone_number: '',
		website: '',
		region: '',
		country: '',
		lead_type: '',
		lead_status: 'pending',
		partner_associated: USER_ID,
		is_lead: 1,
		converted_by: '',
		converted_date: '',
		created_at: '',
		lead_notes: ''
	});


	const handleClose = () => {
		setShow(false);
		setSuccess('');
		setError('');
		resetForm();
		resetFormValidation();
	};
	const handleShow = () => {
		setShow(true);
		setSuccess('');
		setError('');
		resetForm();
		resetFormValidation();
	};

	const resetForm = () => {
		setLeadData({
			fname: '',
			lname: '',
			email: '',
			company_name: '',
			phone_number: '',
			website: '',
			region: '',
			country: '',
			lead_type: '',
			lead_status: 'pending',
			partner_associated: USER_ID,
			is_lead: 1,
			converted_by: '',
			converted_date: '',
			created_at: '',
			lead_notes: ''
		});
	};

	let type = localStorage.getItem('type') || '';

	let fetchDataapiUrl = ``;
	
	if (role === 'admin') {
		fetchDataapiUrl = `${BASE_URL}leads/`;
	}
	if (role == 'partner') {
		if(type == 'partner-admin'){
			fetchDataapiUrl = `${BASE_URL}leads/company/${USER_ID}`;
		} else {
		fetchDataapiUrl = `${BASE_URL}leads/partner/${USER_ID}`;
		}
	}


	const fetchData = async (source) => {
		try {
			const response = await axios.get(fetchDataapiUrl, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${TOKEN}`,
				},
				cancelToken: source.token,
			});
			// console.log('response', response);
			if (response.status !== 200) {
				throw new Error('Failed to fetch users');
			}
			const leadresponseData = response.data;
			setData(leadresponseData.data); // Set fetched data to state

			// Destroy existing DataTable instance if it exists
			if ($.fn.DataTable.isDataTable('#datatablesSimple')) {
				$('#datatablesSimple').DataTable().destroy();
			}

			// Define the table columns based on the user's role
			let columns = [
				{ data: 'id', defaultContent: '' },
				{ data: 'fname' },
				{ data: 'lname' },
				{ data: 'email' },
				{ data: 'company_name' },
			];
			const hasPartnerName = leadresponseData.data.some(
				(entry) => entry.partner && entry.partner.name
			);

			if (role == 'admin' && hasPartnerName) {
				columns.push({ data: 'partner.name' });
			}
			columns.push(
				{
					data: 'lead_status',
					render: function (data) {
						// Assuming data contains the status value (e.g., 'active', 'pending', etc.)
						// Define the Bootstrap tag class based on the status value
						let tagClass;
						if (data === null || data === undefined) {
							return ''; // Return an empty string if data is null or undefined
						}
						switch (data.toLowerCase()) {
							case 'approved':
								tagClass = 'badge badge-pill bg-success';
								break;
							case 'pending':
								tagClass = 'badge badge-pill bg-warning text-dark';
								break;
							case 'rejected':
								tagClass = 'badge badge-pill bg-dark';
								break;
							case 'converted':
								tagClass = 'badge badge-pill bg-primary';
								break;
							default:
								tagClass = 'badge badge-pill bg-info';
						}

						// Construct the Bootstrap tag with the appropriate class and status text
						const tagMarkup = `<span class="${tagClass}">${data}</span>`;

						// Return the HTML markup for the Bootstrap tag
						return tagMarkup;
					}
				},
				{
					data: 'created_at_formated',
					render: function (data) {
						// Parse the date string into a Date object

						return data;
					},
				},
				{
					data: 'id',
					render: function (pid) {
						return `
								<div class="btn-group btn-group-sm" role="group" aria-label="Small button group">
									<button class="btn btn-outline-secondary editLead" >Edit</a>					
								</div>
							`;
					},
				}
			);

			$('#datatablesSimple').DataTable({
				data: leadresponseData.data,
				columns: columns,
				order: [0, 'desc'], // Disable initial sorting
				createdRow: function (row, data, dataIndex) {
					// Bind click event to the buttons inside the created row
					$(row)
						.find('.editLead')
						.on('click', function () {
							editLead(data.id);
						});
				}
			});
			setLoading(false);
		} catch (error) {
			if (axios.isCancel(error)) {
				// console.log('Request cancelled');
			} else {
				setLoading(false);
				if(error.response.status == 401){
                    onLogout();
                }
				// handle other errors
			}
		}
	};


	useEffect(() => {
		const source = axios.CancelToken.source();
		fetchData(source);
		return () => {
			source.cancel('Operation canceled by the user.');
		};
	}, []);

	useEffect(() => {
		let hideTimeout;
		let removeTimeout;
	
		if (success || error) {
		  // Start fading out before removing
		  hideTimeout = setTimeout(() => {
			setFadeOut(true);
		  }, 2000); // Start fading out 0.5 seconds before removing
	
		  // Remove the alert after the fade-out transition
		  removeTimeout = setTimeout(() => {
			setSuccess(null);
			setError(null);
			setFadeOut(false); // Reset fadeOut for future alerts
		  }, 5000); // Remove after 2 seconds
		}
	
		return () => {
		  clearTimeout(hideTimeout);
		  clearTimeout(removeTimeout);
		};
	  }, [success, error]);





	const handleSubmit = async () => {
		if (!validateForm()) {
			return;
		}
		try {
			const response = await fetch(`${BASE_URL}contacts/`, {
				method: 'POST', // Use PUT method for updating
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${TOKEN}`,
				},
				body: JSON.stringify(leadData), // Send updated data in the request body
			});
			const leadresponseData = await response.json();
			if (response.ok) {
				setError('');
				setSuccess('Lead Created successfully');
				const source = axios.CancelToken.source();
				fetchData(source);
				resetForm();
				setShow(false);
			} else {
				// Handle login error (e.g., display error message)
				if (leadresponseData.data.email) {
					setEmailError(leadresponseData.data.email[0]);
				} else {
					setError('Error updating partner ', error);
				}
			}
			// console.log('Lead created successfully');
		} catch (error) {
			setSuccess('');
			setError('Error Creating Lead:', error);
			// console.error('Error  Lead:', error);
		}
		// console.log('Lead created successfully');
		window.scrollTo(0, 0);
	};

	const validateForm = () => {
		let isValid = true;
		if (!leadData.fname) {
			setFirstNameError('First name is required');
			isValid = false;
		} else {
			setFirstNameError('');
		}
		if (!leadData.lname) {
			setLastNameError('Last name is required');
			isValid = false;
		} else {
			setLastNameError('');
		}
		if (!leadData.email) {
			setEmailError('Email address is required');
		}
		else if (!isValidEmail(leadData.email)) {
			setEmailError('Valid email address is required');
			isValid = false;
		} else {
			setEmailError('');
		}

		if (!leadData.company_name) {
			setCompanyNameError('Company name is required');
			isValid = false;
		} else {
			setCompanyNameError('');
		}
		if (!leadData.website) {
			setWebsiteError('Website is required');
			isValid = false;
		} else {
			setWebsiteError('');
		}
		if (!leadData.phone_number) {
			setPhoneError('Phone Number is required');
			isValid = false;
		} else {
			setPhoneError('');
		}
		if (!leadData.region) {
			setRegionError('Region is required');
			isValid = false;
		} else {
			setRegionError('');
		}
		if (!leadData.country) {
			setCountryError('Region is required');
			isValid = false;
		} else {
			setCountryError('');
		}
		if (!leadData.lead_type) {
			setLeadTypeError('Lead type is required');
			isValid = false;
		} else {
			setLeadTypeError('');
		}
		if (role == 'admin') {
			if (!leadData.lead_status) {
				setLeadStatusError('Lead status is required');
				isValid = false;
			} else {
				setLeadStatusError('');
			}
		}
		return isValid;
	};

	const resetFormValidation = () => {
		setFirstNameError('');
		setLastNameError('');
		setEmailError('');
		setCompanyNameError('');
		setWebsiteError('');
		setPhoneError('');
		setRegionError('');
		setCountryError('');
		setLeadTypeError('');
		setLeadStatusError('');
	};
	const isValidEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};
	return (
		<div className="sb-nav-fixed">
			<Navbar userName={userName} role={role} onLogout={onLogout} />
			<div id="layoutSidenav">
				<Sidebar role={role} onLogout={onLogout} page='leads' />
				<div id="layoutSidenav_content">
					<main>
					<div className="container-fluid position-relative px-4">
                       
					   {success && <div className= { `position-absolute start-50 translate-middle-x w-25 m-auto py-2 alert alert-success alert-dismissible  mb-0 fade show${fadeOut ? 'alert-fade-out' : ''}`} role="alert">{success}<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() =>setSuccess(null)}></button></div>}
					   {error && <div className= { `position-absolute start-50 translate-middle-x w-25 m-auto py-2 alert alert-danger alert-dismissible mb-0 fade show${fadeOut ? 'alert-fade-out' : ''}`} role="alert">{error}<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() =>setError(null)}></button></div>}
							<div className="row align-items-center justify-content-between">
								<div className="col-md-6">
									<h1 className="fs-4 mb-0">Leads</h1>
								</div>
								<div className="col-md-6 text-end">
									<button className="btn btn-primary" onClick={handleShow}>+ Add Lead</button>
									<Modal show={show} dialogClassName="modal-right mt-0 me-0 mb-0 modal-xl">
										<div className="modal-content" style={{ animation: 'slideFromRight 0.3s forwards' }}>
											<Modal.Header>
												<Modal.Title>Add Lead</Modal.Title>
												<button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
											</Modal.Header>
											<Modal.Body >
												{success && <div className="alert alert-success alert-dismissible fade show" role="alert">{success}</div>}
												{error && <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}</div>}
												<form className="" onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
													<div className='custom-modal-ht'>
														<div className="row mb-4">
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${firstNameError && 'is-invalid'}`} id="inputFirstName" type="text" placeholder="Enter your first name" value={leadData.fname} onChange={(e) => { setLeadData({ ...leadData, fname: e.target.value }); setFirstNameError(e.target.value.trim() === '' ? 'First name is required' : ''); }} />
																	<label htmlFor="inputFirstName">First name</label>
																	{firstNameError && <div className="invalid-feedback">{firstNameError}</div>}
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${lastNameError && 'is-invalid'}`} id="inputLastName" type="text" placeholder="Enter your last name" value={leadData.lname} onChange={(e) => { setLeadData({ ...leadData, lname: e.target.value }); setLastNameError(e.target.value.trim() === '' ? 'Last name is required' : ''); }} />
																	<label htmlFor="inputLastName">Last name</label>
																	{lastNameError && <div className="invalid-feedback">{lastNameError}</div>}
																</div>
															</div>

														</div>
														<div className="row mb-4">
															<div className="col-md-6">
																<div className="form-floating">
																	<input type="email" className={`form-control ${emailError && 'is-invalid'}`} id="floatingInput" placeholder="name@example.com" value={leadData.email} onChange={(e) => { setLeadData({ ...leadData, email: e.target.value }); setEmailError(e.target.value.trim() === '' ? 'Email address is required' : ''); }} />
																	<label htmlFor="floatingInput">Email Address</label>
																	{emailError && <div className="invalid-feedback">{emailError}</div>}
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${companyNameError && 'is-invalid'}`} id="inputCompany" type="text" placeholder="Enter your company name" value={leadData.company_name} onChange={(e) => { setLeadData({ ...leadData, company_name: e.target.value }); setCompanyNameError(e.target.value.trim() === '' ? 'Company name is required' : ''); }} />
																	<label htmlFor="inputCompany">Company</label>
																	{companyNameError && <div className="invalid-feedback">{companyNameError}</div>}
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${phoneError && 'is-invalid'}`} id="inputPhoneNumber" type="tel" placeholder="Enter your phone number" value={leadData.phone_number} onChange={(e) => { setLeadData({ ...leadData, phone_number: e.target.value }); setPhoneError(e.target.value.trim() === '' ? 'Phone number is required' : ''); }} />
																	<label htmlFor="inputPhoneNumber">Phone Number</label>
																	{phoneError && <div className="invalid-feedback">{phoneError}</div>}
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${websiteError && 'is-invalid'}`} id="inputWebsite" type="text" placeholder="Enter website" value={leadData.website} onChange={(e) => { setLeadData({ ...leadData, website: e.target.value }); setWebsiteError(e.target.value.trim() === '' ? 'Website is required' : ''); }} />
																	<label htmlFor="inputWebsite">Website</label>
																	{websiteError && <div className="invalid-feedback">{websiteError}</div>}
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${regionError && 'is-invalid'}`} id="inputRegion" type="text" placeholder="Enter your region" value={leadData.region} onChange={(e) => { setLeadData({ ...leadData, region: e.target.value }); setRegionError(e.target.value.trim() === '' ? 'Region is required' : ''); }} />
																	<label htmlFor="inputRegion">Region</label>
																	{regionError && <div className="invalid-feedback">{regionError}</div>}
																</div>
															</div>
															<div className="col-md-6">
																<div className="form-floating">
																	<input className={`form-control ${countryError && 'is-invalid'}`} id="inputCountry" type="text" placeholder="Enter your country" value={leadData.country} onChange={(e) => { setLeadData({ ...leadData, country: e.target.value }); setCountryError(e.target.value.trim() === '' ? 'Country is required' : ''); }} />
																	<label htmlFor="inputCountry">Country</label>
																	{countryError && <div className="invalid-feedback">{countryError}</div>}
																</div>
															</div>
														</div>
														<div className="row mb-4">
															<div className="col-md-6">
																<div className="form-floating">
																	<select className={`form-select ${leadTypeError ? 'is-invalid' : ''}`} id="inputLeadType" value={leadData.lead_type} onChange={(e) => { setLeadData({ ...leadData, lead_type: e.target.value }); }} >
																		<option value="" disabled>Select Type</option>
																		<option value="VSB (50 or fewer emp.)">VSB</option>
																		<option value="SMB (51-1000 emp.)">SMB</option>
																		<option value="Enterprise (>1000 emp.)">Enterprise</option>
																		<option value="UAE Lead">UAE Lead</option>
																	</select>
																	<label htmlFor="inputLeadType">Lead Type</label>
																	{leadTypeError && <div className="invalid-feedback">{leadTypeError}</div>}
																</div>
															</div>
															{role == 'admin' &&
																<div className="col-md-6">
																	<div className="form-floating">
																		<select className={`form-select ${leadStatusError && 'is-invalid'}`} id="inputStatus" value={leadData.lead_status} onChange={(e) => { setLeadData({ ...leadData, lead_status: e.target.value }); setLeadStatusError(e.target.value.trim() === '' ? 'Lead status is required' : ''); }}>
																			<option disabled value="">Select status</option>
																			<option value="pending">Pending</option>
																			<option value="approved">Approved</option>
																		</select>
																		<label htmlFor="inputStatus">Lead Status</label>
																		{leadStatusError && <div className="invalid-feedback">{leadStatusError}</div>}
																	</div>
																</div>
															}
														</div>
														<div className="row mb-4">
															<div className="col-md-12">
																<div className="form-floating">
																	<textarea className="form-control" id="inputLeadComments" placeholder="Enter lead comments" style={{ height: "100px" }} value={leadData.lead_notes} onChange={(e) => setLeadData({ ...leadData, lead_notes: e.target.value })}></textarea>
																	<label htmlFor="inputLeadComments">Lead Notes</label>
																</div>
															</div>
														</div>
													</div>
													<div className="row">
														<div className="col-md-12 text-end">
															<button className="btn" type="button" onClick={handleClose}>Cancel</button>
															<button type="submit" className="btn btn-primary mx-2">Create Lead</button>
														</div>
													</div>
												</form>
											</Modal.Body>
										</div>
									</Modal>
								</div>
							</div>
							{error && <p>{error}</p>}
							<div className="card my-4">
								<div className="card-body">
									<table id="datatablesSimple" className="table table-bordered text-break">
										<thead className='table-primary'>
											<tr>
												<th>ID</th>
												<th>First Name</th>
												<th>Last Name</th>
												<th>Email</th>
												<th>Company Name</th>
												{role == 'admin' && <th>Partner Name</th>}
												<th>Status</th>
												<th>Created Date</th>
												<th>Action</th>
											</tr>
										</thead>
										<tbody><tr><td colSpan="9">{loading ? ("Loading...") : ("No Records Found")}</td></tr></tbody>
									</table>
								</div>
							</div>

						</div>
					</main>
				</div>
			</div>
		</div>
	);
};

export default Leads;
